export default "__VITE_ASSET__e27eb05a__"